<!--=============================
=            SLIDERS            =
==============================-->
<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Sliders</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Min & Max values</div>
          <div slot="card-body">
            <div>
              <v-row justify="space-around">
                <v-col cols="12">
                  <v-slider v-model="min" min="-100" max="100" label="Min"></v-slider>
                </v-col>
                <v-col cols="12">
                  <v-slider v-model="max" min="-100" max="100" label="Max"></v-slider>
                </v-col>
                <v-switch v-model="disabled" class="ma-2" label="Disabled"></v-switch>
                <v-switch v-model="readonly" class="ma-2" label="Readonly"></v-switch>
                <v-switch v-model="vertical" class="ma-2" label="Vertical"></v-switch>
                <v-switch v-model="range" class="ma-2" label="Range"></v-switch>
                <v-col cols="12">
                  <v-slider
                    v-if="!range"
                    v-model="volume"
                    append-icon="volume_up"
                    prepend-icon="volume_down"
                    :min="min"
                    :max="max"
                    :disabled="disabled"
                    :readonly="readonly"
                    :vertical="vertical"
                    label="Volume"
                  ></v-slider>
                  <v-range-slider
                    v-else
                    append-icon="volume_up"
                    prepend-icon="volume_down"
                    :min="min"
                    :max="max"
                    :disabled="disabled"
                    :readonly="readonly"
                    :vertical="vertical"
                    label="Volume"
                  ></v-range-slider>
                </v-col>
              </v-row>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Disabled Slots</div>
          <div slot="card-body">
            <div>
              <v-card flat color="transparent">
                <v-subheader>Min and max default slider</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col class="pr-4">
                      <v-slider
                        v-model="slider"
                        class="align-center"
                        :max="max"
                        :min="min"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="slider"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-subheader>Min and max range slider</v-subheader>

                <v-card-text>
                  <v-row>
                    <v-col class="px-4">
                      <v-range-slider
                        v-model="range"
                        :max="max"
                        :min="min"
                        hide-details
                        class="align-center"
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            v-model="range[0]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                        <template v-slot:append>
                          <v-text-field
                            v-model="range[1]"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-range-slider>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Readonly</div>
          <div slot="card-body">
            <div>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-slider readonly label="Readonly" value="30"></v-slider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Icons</div>
          <div slot="card-body">
            <div>
              <v-card flat color="transparent">
                <v-subheader>Media volume</v-subheader>
                <v-card-text>
                  <v-slider v-model="media" prepend-icon="volume_up"></v-slider>
                </v-card-text>

                <v-subheader>Alarm volume</v-subheader>

                <v-card-text>
                  <v-slider v-model="alarm" append-icon="alarm"></v-slider>
                </v-card-text>

                <v-subheader>Icon click callback</v-subheader>

                <v-card-text>
                  <v-slider
                    v-model="zoom"
                    append-icon="zoom_in"
                    prepend-icon="zoom_out"
                    @click:append="zoomIn"
                    @click:prepend="zoomOut"
                  ></v-slider>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Vertical sliders</div>
          <div slot="card-body">
            <div>
              <v-container>
                <v-row>
                  <v-slider v-model="value" vertical label="Regular"></v-slider>
                  <v-range-slider v-model="value2" vertical label="Range"></v-range-slider>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Thumb</div>
          <div slot="card-body">
            <div>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-subheader class="pl-0">Show thumb when using slider</v-subheader>
                    <v-slider v-model="slider" thumb-label></v-slider>
                  </v-col>

                  <v-col cols="12">
                    <v-subheader class="pl-0">Always show thumb label</v-subheader>
                    <v-slider v-model="slider" thumb-label="always"></v-slider>
                  </v-col>

                  <v-col cols="12">
                    <v-subheader class="pl-0">Custom thumb size</v-subheader>
                    <v-slider v-model="slider" :thumb-size="24" thumb-label="always"></v-slider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Inverse label</div>
          <div slot="card-body">
            <div>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    <v-slider inverse-label label="Inverse label" value="30"></v-slider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Ticks</div>
          <div slot="card-body">
            <div>
              <v-card flat color="transparent">
                <v-subheader>Show ticks when using slider</v-subheader>

                <v-card-text>
                  <v-slider v-model="value" step="10" ticks></v-slider>
                </v-card-text>

                <v-subheader>Always show ticks</v-subheader>

                <v-card-text>
                  <v-slider v-model="value" step="10" ticks="always"></v-slider>
                </v-card-text>

                <v-subheader>Tick size</v-subheader>

                <v-card-text>
                  <v-slider v-model="value" step="10" ticks="always" tick-size="4"></v-slider>
                </v-card-text>

                <v-subheader>Tick labels</v-subheader>

                <v-card-text>
                  <v-slider
                    v-model="fruits"
                    :tick-labels="ticksLabels"
                    :max="3"
                    step="1"
                    ticks="always"
                    tick-size="4"
                  ></v-slider>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Ranger</div>
          <div slot="card-body">
            <div>
              <v-card flat color="transparent">
                <v-subheader>Default range slider</v-subheader>
                <v-card-text>
                  <v-range-slider v-model="value1"></v-range-slider>
                </v-card-text>

                <v-subheader>Disabled range slider</v-subheader>
                <v-card-text>
                  <v-range-slider v-model="value2" disabled></v-range-slider>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom colors</div>
          <div slot="card-body">
            <div>
              <div>
                <v-slider v-model="ex1.val" :color="ex1.color" :label="ex1.label"></v-slider>

                <v-slider v-model="ex2.val" :label="ex2.label" :track-color="ex2.color"></v-slider>

                <v-slider
                  v-model="ex3.val"
                  :label="ex3.label"
                  :thumb-color="ex3.color"
                  thumb-label="always"
                ></v-slider>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Validation</div>
          <div slot="card-body">
            <div>
              <v-card flat color="transparent">
                <v-subheader>Rules</v-subheader>

                <v-card-text class="pt-0">
                  <v-slider
                    v-model="value"
                    :rules="rules"
                    label="How many?"
                    step="10"
                    thumb-label="always"
                    ticks
                  ></v-slider>
                </v-card-text>

                <v-subheader>Persistent hint</v-subheader>

                <v-card-text class="pt-0">
                  <v-slider
                    v-model="value"
                    :rules="rules"
                    hint="40 in stock"
                    label="How many?"
                    persistent-hint
                    step="10"
                    thumb-label="always"
                    ticks
                  ></v-slider>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Slots</div>
          <div slot="card-body">
            <div>
              <v-card class="mx-auto" max-width="600">
                <v-toolbar flat dense>
                  <v-toolbar-title>
                    <span class="subheading">METRONOME</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon>mdi-share-variant</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-card-text>
                  <v-row class="mb-4" justify="space-between">
                    <v-col class="text-left">
                      <span class="display-3 font-weight-light" v-text="bpm"></span>
                      <span class="subheading font-weight-light mr-1">BPM</span>
                      <v-fade-transition>
                        <v-avatar
                          v-if="isPlaying"
                          :color="color"
                          :style="{
                animationDuration: animationDuration
              }"
                          class="mb-1 v-avatar--metronome"
                          size="12"
                        ></v-avatar>
                      </v-fade-transition>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn :color="color" dark depressed fab @click="toggle">
                        <v-icon large>{{ isPlaying ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-slider
                    v-model="bpm"
                    :color="color"
                    track-color="grey"
                    always-dirty
                    min="40"
                    max="218"
                  >
                    <template v-slot:prepend>
                      <v-icon :color="color" @click="decrement">mdi-minus</v-icon>
                    </template>

                    <template v-slot:append>
                      <v-icon :color="color" @click="increment">mdi-plus</v-icon>
                    </template>
                  </v-slider>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    value: 30,
    rules: [v => v <= 40 || "Only 40 in stock"],
    bpm: 40,
    interval: null,
    isPlaying: false,
    ex1: {
      label: "color",
      val: 25,
      color: "orange darken-3"
    },
    ex2: {
      label: "track-color",
      val: 75,
      color: "green lighten-1"
    },
    ex3: {
      label: "thumb-color",
      val: 50,
      color: "red"
    },
    volume: 10,
    min: 0,
    max: 100,
    disabled: false,
    readonly: false,
    vertical: false,
    range: false
  }),

  computed: {
    color() {
      if (this.bpm < 100) return "indigo";
      if (this.bpm < 125) return "teal";
      if (this.bpm < 140) return "green";
      if (this.bpm < 175) return "orange";
      return "red";
    },
    animationDuration() {
      return `${60 / this.bpm}s`;
    }
  },

  methods: {
    decrement() {
      this.bpm--;
    },
    increment() {
      this.bpm++;
    },
    toggle() {
      this.isPlaying = !this.isPlaying;
    }
  }
};
</script>


<!--====  End of SLIDERS  ====-->
